import React, {useContext, useState} from 'react';
import {fetchSendersList, runScript} from "../../services";
import Fetch from "../../Elements/Fetch";
import FormGroupRowSender from "../../Elements/FormGroupRowSender";
import FormGroupRowDate from "../../Elements/FormGroupRowDate";
import FormGroupRowSelect from "../../Elements/FormGroupRowSelect";
import FormGroupRowText from "../../Elements/FormGroupRowText";
import useSubmittingButton from "../../hooks/useSubmittingButton";
import {Col, Row} from "reactstrap";
import {ModalContext} from "../../Modal/ModalProvider";

const TransactionOverviewReport = () => {

    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [beneficiaryIban, setBeneficiaryIban] = useState('');
    const [senders, setSenders] = useState([]);
    const [paymentStatuses, setPaymentStatuses] = useState([]);

    const {errorMessage, loader, SubmittingButton} = useSubmittingButton();
    const {showModal} = useContext(ModalContext);

    const handleSubmit = async () => {
        const response = await runScript('TransactionOverviewReport', {
            dateFrom: dateFrom,
            dateTo: dateTo,
            beneficiaryIban: beneficiaryIban,
            senderIds: senders,
            paymentStatuses: paymentStatuses,
        });

        if (response.status === 200) {
            const data = await response.json();

            showModal({
                type: 'download',
                exportId: data.id,
            });
        }
        else {
            throw new Error(`${response.status}: ${response.statusText}. Contact a site administrator. This error probably won't go away by itself.`);
        }
    };

    const disabled = !dateFrom || !dateTo || senders.length === 0;

    return (
        <>
            <h4>Transaction Overview Report</h4>

            {errorMessage}

            <form style={{maxWidth: 600}}>
                <FormGroupRowDate
                    label="Date from"
                    value={dateFrom}
                    onChange={setDateFrom}
                    description="This date is included in the export."
                />

                <FormGroupRowDate
                    label="Date to"
                    value={dateTo}
                    onChange={setDateTo}
                    description="This date is included in the export."
                />

                <Fetch fetchFunction={fetchSendersList} className="form-group">
                    {senderList => (
                        <FormGroupRowSender
                            label="Sender"
                            value={senders}
                            onChange={setSenders}
                            senders={senderList}
                            multi
                        />
                    )}
                </Fetch>

                <FormGroupRowSelect
                    label="Payment status"
                    value={paymentStatuses}
                    onChange={setPaymentStatuses}
                    description="Leave empty for all payment statuses."
                    multi
                    options={[
                        {value: 'COMPLETED', label: 'COMPLETED'},
                        {value: 'REFUSED', label: 'REFUSED'},
                        {value: 'CANCELED', label: 'CANCELED'},
                        {value: 'DELAYED', label: 'DELAYED'},
                        {value: 'NEW', label: 'NEW'},
                        {value: 'ERROR', label: 'ERROR'},
                        {value: 'INTERNAL_ERROR', label: 'INTERNAL_ERROR'},
                        {value: 'PROCESSING', label: 'PROCESSING'},
                        {value: 'COMPLETE', label: 'COMPLETE'},
                        {value: 'FAILED', label: 'FAILED'},
                        {value: 'TIMEOUT', label: 'TIMEOUT'},
                        {value: 'CANCELLED', label: 'CANCELLED'},
                        {value: 'REFUNDED', label: 'REFUNDED'},
                    ]}
                />

                <FormGroupRowText
                    label="Beneficiary IBAN"
                    description="Optionally enter a full or partial IBAN number."
                    value={beneficiaryIban}
                    onChange={setBeneficiaryIban}
                />

                <Row form className="align-items-center">
                    <Col xs="auto">
                        <SubmittingButton onClick={handleSubmit} disabled={disabled}>Submit</SubmittingButton>
                    </Col>
                    <Col xs="auto">
                        {loader}
                    </Col>
                </Row>
            </form>
        </>
    );
};

export default TransactionOverviewReport;
